"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsTable = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var copy_1 = require("../../../../../copy");
var values_1 = require("../../../../../utils/values");
var BillingDetails_styled_1 = require("../BillingDetails.styled");
var meter_readings_table_1 = require("./meter-readings-table");
exports.MeterReadingsTable = (0, react_1.forwardRef)(function (_a, ref) {
    var supplyPointRegisterCharges = _a.supplyPointRegisterCharges, fuel = _a.fuel, rest = __rest(_a, ["supplyPointRegisterCharges", "fuel"]);
    var _b = (0, core_1.useComponents)(), DataTable = _b.DataTable, Heading4 = _b.Heading4, Stack = _b.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var captions = (0, meter_readings_table_1.useConsumptionRows)(supplyPointRegisterCharges, fuel);
    return (react_1.default.createElement("div", __assign({}, rest, { ref: ref }),
        react_1.default.createElement(Heading4, null,
            react_1.default.createElement(Copy, { copyKey: "meterReadingsHeader" })),
        react_1.default.createElement(Stack, { spaceBetween: [4] }, captions.map(function (supplyRegiserConsumption) {
            return (react_1.default.createElement("div", { key: "".concat(supplyRegiserConsumption.sprn || fuel, "_").concat(supplyRegiserConsumption.friendlyLabel), "data-testid": "".concat(supplyRegiserConsumption.sprn || fuel, "_").concat(supplyRegiserConsumption.friendlyLabel) }, supplyRegiserConsumption.sortedRows.length ? (supplyRegiserConsumption.sortedRows.map(function (row) {
                var items = row.readings.map(function (_a) {
                    var description = _a.description, readTypeContext = _a.readTypeContext, reading = _a.reading;
                    return [
                        description,
                        react_1.default.createElement(react_1.default.Fragment, null,
                            readTypeContext,
                            " ",
                            (0, values_1.round)(reading, 3)),
                    ];
                });
                items.push([
                    supplyRegiserConsumption.isMultiRate ? (react_1.default.createElement(Copy, { copyKey: "meterReadingsTotalLabelWithRegister", props: { friendlyLabel: row.label } })) : (react_1.default.createElement(Copy, { copyKey: "meterReadingsTotalLabel" })),
                    react_1.default.createElement(components_1.NoWrap, { key: "meter-readings-total-".concat(row.label), "data-testid": "meter-readings-total" },
                        react_1.default.createElement(Copy, { copyKey: "meterReadingsTotal", values: { total: (0, values_1.round)(row.totalKwh, 3) } })),
                ]);
                return (react_1.default.createElement(BillingDetails_styled_1.StyledCondensedTable, { as: DataTable, "data-testid": "meter-readings-table", caption: row.title, items: items, key: "meter-readings-table-".concat(row.label) }));
            })) : (react_1.default.createElement(Copy, { copyKey: "meterReadingsEmpty", values: { fuel: fuel } }))));
        }))));
});
